
const digest = '5e73d8e0e7875d0be52ba2a32a6acdb964c8a14bbfed8b5454c0dfe0bd4b947d';
const css = `._codeSnippet_1uny7_1 {
  font-family: monospace;
  color: #d14;
  border: 1px solid #e1e1e8;
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: #f7f7f9;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_1uny7_1"};
export { css, digest };
  